(function() {
    'use strict';

    angular.module('GorillaBoy.Login')
    .controller('AuthSuccessController', [
        '$location',
        '$log',
        '$rootScope',
        '$window',
        'AuthService',
        'UserService',
        'EndpointService',
        'authenticatedUser',
        'localStorageService',
        'BrowserService',
        'AppConstants',
        AuthSuccessController
    ]);

    /*
    * The AuthSuccessController sets Auth tokens (access token and refresh token) in local storage and navigates user to start using Website.
    *
    * This controller is called on successfully obtaining an access token which can be readily used with resource server.
    *
    * -- Access Token & Refresh Token --
    * The access token is used to make authenticated requests to the resource server (e.g. GorillaBoy).
    * It  has a longer lifetime than the authorization code (e.g. GorillaBoy's is 1 hour at
    * the time of this writing). When the access token expires, attempts to use it will fail,
    * and a new access token must be obtained via the refresh token.
    *
    */
    function AuthSuccessController ($location, $log, $rootScope, $window, authService, UserService, endpointService, authenticatedUser, localStorageService, BrowserService, AppConstants) {
        var ACCESS_TOKEN = 'gb_access_token',
            ACCESS_TOKEN_EXPIRATION = 'gb_access_token_exp',
            REFRESH_TOKEN = 'gb_refresh_token',
            WD_FED_ACCESS_TOKEN = "workdocs_federated_token",
            WD_FED_ACCESS_TOKEN_EXP = "workdocs_federated_token_expiration_iso",
            WD_FED_REFRESH_TOKEN = "workdocs_federated_refresh_token";

        activate();

        /**
         * Main function that gets invoked when this controller is activated.
         */
        function activate () {
            $rootScope.metricServiceInstance.putMetric({
                MethodName: "AuthSuccessController.Activate",
                MetricName: "Count",
                Unit: "Count",
                Values: 1
            });
            var orgName = endpointService.organization();
            var querystring_params = $location.search();

            if (querystring_params && querystring_params[AppConstants.WorkDocsAuthParams.ACCESS_TOKEN] &&
                querystring_params[AppConstants.WorkDocsAuthParams.ACCESS_TOKEN_EXPIRATION]) { // Refresh Token is optional

                processAuthTokens(
                    querystring_params[AppConstants.WorkDocsAuthParams.ACCESS_TOKEN],
                    querystring_params[AppConstants.WorkDocsAuthParams.ACCESS_TOKEN_EXPIRATION],
                    querystring_params[AppConstants.WorkDocsAuthParams.REFRESH_TOKEN]
                );
            } else if(localStorageService.get(orgName+'.'+WD_FED_ACCESS_TOKEN) && localStorageService.get(orgName+'.'+WD_FED_ACCESS_TOKEN_EXP)){

                processAuthTokens(
                    localStorageService.get(orgName+'.'+WD_FED_ACCESS_TOKEN),
                    localStorageService.get(orgName+'.'+WD_FED_ACCESS_TOKEN_EXP),
                    localStorageService.get(orgName+'.'+WD_FED_REFRESH_TOKEN)
                );

            } else {
                // If there is no auth token as a param, there's nothing we can do other than redirect to login page
                $location.url('/login').replace();
            }
        }

        /**
         * Store WorkDocs access token to local storage
         *
         * Note: this has nothing to do with success/failure of refreshing an access token.
         * This controller only deals with the creation of an access token by exchanging a short-lived
         * authorization code for an access token.
         */
        function processAuthTokens (accessToken, accessTokenExpiry, refreshToken, loadUserInfo) {
            // store access token to local storage
            localStorageService.set(ACCESS_TOKEN, accessToken);
            localStorageService.set(ACCESS_TOKEN_EXPIRATION, accessTokenExpiry);
            if (refreshToken) {
                $log.info(new Date().toISOString() + ' [AuthSuccessController] Refresh token was passed. Setting refresh token in local storage.');
                localStorageService.set(REFRESH_TOKEN, refreshToken);
            } else {
                $log.info(new Date().toISOString() + ' [AuthSuccessController] No refresh token passed. Removing existing refresh token from local storage if any.');
                localStorageService.remove(REFRESH_TOKEN);
            }

            if (!authService.isAuthenticated()) {
                authService
                    .getUserInfo(true)
                    .then(redirectFromLogin, function() {
                        $location.url("/login").replace();
                    });
                return;
            } else {
                redirectFromLogin();
            }
        }

        /**
         * Extracts the originally requested URL from the cookie and redirects the user to that route.
         */
        function redirectFromLogin() {
            var WD_REDIRECT_URL = 'wd_redirect_url',
                WD_DESTINATION_PATH = 'wd_dest_path', //optional destination url provided in the query string
                defaultPathWithoutStartingSlash = 'mydocs',
                returnUrl;

            $log.info(new Date().toISOString() + ' [AuthSuccessController] In redirectFromLogin()');

            // Set the correct return url based on whether any value was set in the
            // the session storage by login controller before redirection to authentication
            // service.
            try {
                returnUrl = $window.sessionStorage.getItem(WD_REDIRECT_URL);
            } catch (e) {
                returnUrl = getCookie(WD_REDIRECT_URL);
            }

            if (!returnUrl) {
                // Check if a destination has been provided on the query string
                var query_params = $location.search();
                if (query_params && query_params[WD_DESTINATION_PATH]) {
                    returnUrl = query_params[WD_DESTINATION_PATH];
                }
            }

            if (!returnUrl) {
                // set default path to /mydocs page if no return Url is present.
                returnUrl = defaultPathWithoutStartingSlash;
            }

            returnUrl = decodeURIComponent(returnUrl).trim();
            if (returnUrl.startsWith('/')) {
                //Remove the starting slash if it exists
                returnUrl = returnUrl.substring(1);
            }

            //Do not use path() here as it'll not set search() params properly
            //instead use url() which handles both
            //Let all the routing happen from login controller
            $location.url('/login?redirectPath=' + encodeURIComponent(returnUrl)).replace();

            // clean up session storage.
            try {
                $window.sessionStorage.removeItem(WD_REDIRECT_URL);
            } catch (e) {
                document.cookie = WD_REDIRECT_URL + '=;';
            }
        }

        function getCookie(name) {
            var value = '; ' + document.cookie,
                parts = value.split('; ' + name + '=');
            if (parts.length === 2) {
                return parts.pop().split(';').shift();
            }
        }
    }
}());
